import { createArizonaMockCoordinate, createSeededMockRandom } from "./mock-geo.js";
import { HEX_POC_SYMPTOMS } from "./symptoms.js";

export const MOCK_REPORT_COUNT = 1_000;
export const MOCK_REPORT_DATASET_VERSION = "mock-human-reports-325-2026-v1";

const MOCK_REPORT_SEED = 325_2026;
const MOCK_SYMPTOM_SEED_OFFSET = 0x51f15e;

export function createMockReports({ count = MOCK_REPORT_COUNT, seed = MOCK_REPORT_SEED } = {}) {
  const random = createSeededMockRandom(seed);
  const symptomRandom = createSeededMockRandom(Number(seed) + MOCK_SYMPTOM_SEED_OFFSET);
  return Array.from({ length: count }, (_, index) => {
    const coordinates = createArizonaMockCoordinate(random);
    const sick = random() < 0.37;
    const reportDate = new Date(Date.UTC(2026, 0, 1 + Math.floor(random() * 181))).toISOString().slice(0, 10);
    const symptoms = sick ? createMockSymptoms(symptomRandom) : Object.freeze([]);
    return Object.freeze({
      id: `mock-report-${String(index + 1).padStart(4, "0")}`,
      ...coordinates,
      status: sick ? "sick" : "healthy",
      reportDate,
      symptoms,
    });
  });
}

export { isWithinArizonaMockBounds } from "./mock-geo.js";

function createMockSymptoms(random) {
  const symptomCount = 1 + Math.floor(random() * 3);
  const available = [...HEX_POC_SYMPTOMS];
  const symptoms = [];
  while (symptoms.length < symptomCount) {
    const index = Math.floor(random() * available.length);
    symptoms.push(available.splice(index, 1)[0]);
  }
  return Object.freeze(symptoms);
}
